import { PriceObjectDtoSchema } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { HUImageDtoSchema } from "@modules/dtos/imageDto"
import { CoachDtoSchema } from "@modules/profile/profileDtos"
import { ProgramVisibility } from "@modules/programs/programTypes"
import { UserProgramItemDtoSchema } from "@modules/programs/services/programDto"
import { z } from "zod"

export const ProgramBundleTypeOf = "PROGRAM_BUNDLE"

export enum ProgramBundleType {
  ON_OFF = "ON_OFF",
  VIRTUAL = "VIRTUAL",
}

export const PROGRAM_BUNDLE_NAME_MAX_LENGTH = 250
export const PROGRAM_BUNDLE_DESCRIPTION_MAX_LENGTH = 65530

export const LightProgramBundleInfoDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  image: HUImageDtoSchema.nullable(),
  price: PriceObjectDtoSchema.nullable(),
  type: z.nativeEnum(ProgramBundleType),
})

export const ProgramBundleDtoSchema = z.object({
  id: z.string(),
  type: z.nativeEnum(ProgramBundleType),
  name: z.string(),
  description: z.string(),
  visibility: z.nativeEnum(ProgramVisibility),
  image: HUImageDtoSchema.nullable(),
  invitationLink: z.string().nullable(),
  owner: CoachDtoSchema,
  subscriptionCount: z.number(),
  price: PriceObjectDtoSchema.nullable(),
  programs: z.array(z.lazy(() => UserProgramItemDtoSchema)),
  nbPrograms: z.number(),
  trialDuration: z.number().nullable(),
  isEligibleToTrial: z.boolean().nullable(),
})

export const ProgramBundleDraftDtoSchema = z.object({
  name: z.string().max(PROGRAM_BUNDLE_NAME_MAX_LENGTH),
  description: z.string().max(PROGRAM_BUNDLE_DESCRIPTION_MAX_LENGTH),
  visibility: z.nativeEnum(ProgramVisibility),
  type: z.nativeEnum(ProgramBundleType),
  imageWeb: HUImageDtoSchema.nullable(),
  price: PriceObjectDtoSchema.nullable(),
  programIds: z.array(z.string()),
  trialDuration: z.number().nullable(),
})

export const ProgramBundleLightDtoSchema = z.object({
  programBundleId: z.string(),
  programBundleName: z.string(),
  paidPrice: PriceObjectDtoSchema.nullable(),
})

export type ProgramBundleDraftDto = z.infer<typeof ProgramBundleDraftDtoSchema>
export type ProgramBundleDto = z.infer<typeof ProgramBundleDtoSchema>
export type ProgramBundleLightDto = z.infer<typeof ProgramBundleLightDtoSchema>
export type LightProgramBundleInfoDto = z.infer<typeof LightProgramBundleInfoDtoSchema>
